// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1-kv_Q8Nnz7EOpo_Ro042h","attn":"_3YRMvXUDHHwWeQhvlKoCkh"};